"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreakdownTypes = void 0;
exports.BreakdownTypes = {
    ItemsTotal: 'itemsTotal',
    Shipping: 'shipping',
    Tax: 'tax',
    Discount: 'discount',
};
//# sourceMappingURL=PaymentBreakdown.js.map